export const BASE_URL_API_TRANXT_UAT_API = `https://api.shubhpaisa.com/api/ShubhPaisa`;

export const BASE_URL_API_TRANX_BLOG = `https://blogapi.packky.com/api/Bumppy`;

